import React, { useContext } from "react";

import AddItem from "../../../../nucleus/add-item/add-item";
import CustomConsiderationField from "./components/customConsiderationsField";
import FileUploadAccordian from "../../file-upload-accordian";
import { getRandomId } from "../../../../utils/validation-utils";
import LeaseAbstractionContext from "../../contexts/leaseAbstractionContext";
import SortableList from '../../../../components/voucher/ConsiderationTab/SortableListLocal';

const Considerations = () => {
  const {
    modalFieldState,
    modalFieldChangeHandler,
    individualModalFieldChangeHandler,
    findFieldRef,
  } = useContext(LeaseAbstractionContext);

  const handleOrderChange = (oldIndex, newIndex) => {
    const updatedTableConfig = [...modalFieldState.customConsideration.value];
    if (oldIndex < 0 || oldIndex >= updatedTableConfig.length || newIndex < 0 || newIndex >= updatedTableConfig.length) {
      return;
    }
    const reorderedTableConfig = updatedTableConfig.splice(oldIndex, 1)[0];
    updatedTableConfig.splice(newIndex, 0, reorderedTableConfig);
    modalFieldChangeHandler('customConsideration', { value: updatedTableConfig });
  };

  const sortableOpts = modalFieldState.customConsideration.value.map(
    (customConsideration) => (
      <CustomConsiderationField
        currentCustomConsideration={customConsideration}
        key={customConsideration.id}
      />
    )
  );
  return (
    <FileUploadAccordian accordianTitle="Considerations">
      {/* key = customConsideration */}
      <div className="file-modal-sub-heading-container">
        <p className="file-modal-sub-heading">Consideration Breakdown</p>{' '}
        <p className="file-modal-sub-heading-page">
          {modalFieldState.customConsideration.toolTip?.pageIndex?.length >
            0 && (
            <p className="acc-page-info">
              <div
                className="acc-page-number"
                onClick={() => {
                  const pageIndex = parseInt(modalFieldState.customConsideration.toolTip.pageIndex, 10);
                  if (!Number.isNaN(pageIndex)) {
                    findFieldRef(
                      'customConsideration',
                      pageIndex,
                    );
                  } else {
                    console.error('Invalid page index:');
                  }
                }}
              >
                Page: {modalFieldState.customConsideration.toolTip.pageIndex}
              </div>
            </p>
          )}
        </p>
      </div>

      <>
        <SortableList
          className="blx-scrollable blx-sortable-list-reverse blx-sortable-list-item--align-center"
          onDrop={handleOrderChange}
        >
          {sortableOpts}
        </SortableList>
        <div className="file-modal-add-button">
          <AddItem
            label="Add Rent"
            onClick={() => {
              const newCustomConsiderationValue = [
                ...modalFieldState.customConsideration.value,
              ];
              newCustomConsiderationValue.push({
                id: getRandomId(),
                consideration_type: "Monthly Rent",
                total_units: "",
                amount: "",
                consideration_amount: "",
                commission_percent: "",
                commission_dollars: "",
                commission_amount: "",
              });
              modalFieldChangeHandler("customConsideration", {
                value: newCustomConsiderationValue,
              });
              individualModalFieldChangeHandler({
                child_value: newCustomConsiderationValue,
                parent_key: "consideration_info",
                child_key: modalFieldState.customConsideration.trackingID,
                stateVariable: "customConsideration",
              });
            }}
          />
        </div>
      </>
    </FileUploadAccordian>
  );
};

Considerations.propTypes = {};

Considerations.defaultProps = {};

export default Considerations;
